'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import MatchingContent from './components/MatchingContent';

export default function MatchingPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/matching">
        <MatchingContent />
      </AppLayout>
    </RouteGuard>
  );
}
